export default __webpack_public_path__ + "static/media/icebreaker_icon_transparent_-_resources_page-removebg-preview.156eaf94.png";